var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Input, Modal, Typography } from '@robinpowered/ui-kit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export var RsvpCommentModal = function (_a) {
    var open = _a.open, status = _a.status, submitting = _a.submitting, onSubmit = _a.onSubmit, onCancel = _a.onCancel;
    var t = useTranslation('meetingRooms').t;
    var _b = __read(useState(''), 2), comment = _b[0], setComment = _b[1];
    var handleSubmit = function () {
        var trimmed = comment.trim();
        onSubmit(trimmed.length > 0 ? trimmed : null);
        setComment('');
    };
    var handleCancel = function () {
        setComment('');
        onCancel();
    };
    var title = status === 'declined'
        ? t('eventDetails.rsvp.comment_modal_title_declined')
        : t('eventDetails.rsvp.comment_modal_title_tentative');
    return (_jsx(Modal, { open: open, title: title, okText: t('eventDetails.rsvp.comment_modal_submit'), cancelText: t('cancel'), onOk: handleSubmit, confirmLoading: submitting, onCancel: handleCancel, destroyOnHidden: true, footer: [
            _jsx(Button, { onClick: handleCancel, type: "text", children: t('cancel') }, "cancel"),
            _jsx(Button, { onClick: handleSubmit, type: "primary", children: t('eventDetails.rsvp.comment_modal_submit') }, "submit"),
        ], children: _jsxs(Flex, { gap: 4, vertical: true, children: [_jsx(Typography.Text, { type: "secondary", children: t('eventDetails.rsvp.comment_modal_optional') }), _jsx(Input.TextArea, { rows: 4, value: comment, onChange: function (e) { return setComment(e.target.value); }, placeholder: t('eventDetails.rsvp.comment_modal_placeholder') })] }) }));
};
